<template>
  <footer class="footer has-cards">
    <hr>
    <div class="container">
      <div class="row row-grid align-items-center my-md">
        <div class="col-lg-6">
          <h3 class="text-primary font-weight-light mb-2">DogeKongZilla Token Dashboard</h3>
          <!--          <h4 class="mb-0 font-weight-light"></h4>-->
        </div>
        <div class="col-lg-6 btn-wrapper" style="text-align: right">
          <a target="_blank" rel="noopener" href="#"
             class="btn btn-neutral btn-icon-only btn-twitter btn-round btn-lg" data-toggle="tooltip"
             data-original-title="Follow us">
            <i class="fa fa-twitter"></i>
          </a>
          <a target="_blank" rel="noopener" href="#"
             class="btn btn-neutral btn-icon-only btn-facebook btn-round btn-lg" data-toggle="tooltip"
             data-original-title="Like us">
            <i class="fa fa-telegram"></i>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>
</style>
